module.exports = __webpack_public_path__ + "img/mapMarkerIcon.2b859b06.svg";